export default {
    methods: {
        $preventToEnterNegativeNumber(event) {
            if(event.key === '-') {
                event.preventDefault();
            }
        }
    }
}